<h1 mat-dialog-title>{{'Polling policy for {0}'|i18n:data['devId']}}</h1>
<div mat-dialog-content fxLayout="column" class="polling-policy-dialog">
    <form [formGroup]="form" fxLayout="column" *appVar="form.controls.type.value as policy">
        <mat-form-field>
            <mat-select placeholder="{{'Policy__{polling}'|i18n}}" formControlName="type"
                        (selectionChange)="onSelectPolicyType()">
                <mat-option [value]="PollingPolicyType.NONE">{{'None__{polling}'|i18n}}</mat-option>
<!--                <mat-option [value]="PollingPolicyType.INTERVAL">{{'Fixed interval'|i18n}}</mat-option>-->
                <mat-option [value]="PollingPolicyType.CRON">{{'Cron expression'|i18n}}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field *ngIf="policy === PollingPolicyType.INTERVAL">
            <input matInput placeholder="{{'Interval'|i18n}}" formControlName="interval" type="number">
            <span matSuffix>{{'seconds'|i18n}}</span>
            <mat-error *ngIf="form.controls.interval.hasError('bad_interval')">
                {{'Invalid interval'|i18n}}
            </mat-error>
        </mat-form-field>
        <ng-container *ngIf="policy === PollingPolicyType.CRON">
            <mat-form-field>
                <input matInput placeholder="{{'Cron expression'|i18n}}" formControlName="cron">
                <mat-error *ngIf="form.controls.cron.hasError('bad_cron')">
                    {{'Invalid cron expression'|i18n}}
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-select placeholder="{{'Time-zone'|i18n}}" formControlName="timeZone">
                    <mat-option *ngFor="let tz of timeZones" [value]="tz">{{tz}}</mat-option>
                </mat-select>
                <mat-error *ngIf="form.controls.timeZone.hasError('bad_timezone')">
                    {{'Invalid time-zone'|i18n}}
                </mat-error>
            </mat-form-field>
        </ng-container>
    </form>
</div>
<div mat-dialog-actions class="actions">
    <button mat-stroked-button color="primary" [disabled]="!form.valid || !form.dirty"
            [mat-dialog-close]="close()">
        <app-icon name="fal-save"></app-icon>&nbsp;&nbsp;
        {{'Ok'|i18n}}
    </button>
</div>
